import { useChatStore } from '@/store/useChatStore'

export const useChat = () => {
  const openChatStore = useChatStore((state) => state.open)
  const closeChatStore = useChatStore((state) => state.close)

  const open = () => {
    if (typeof window._handleOpenNice === 'undefined') return

    openChatStore()
    window._handleOpenNice()
  }

  const close = () => {
    if (typeof window._handleCloseNice === 'undefined') return

    closeChatStore()
    window._handleCloseNice()
  }

  return {
    close,
    open
  }
}
